import { string } from 'prop-types';
import React from 'react';
import styles from './styles';

function Loading({ height }) {
  const style = {
    height
  };
  return (
    <div className="Loading" style={style}>
      <img
        src="/static/icons/animated-squiggle.svg"
        alt="Loading..."
        height="100"
      />
      <style jsx>{styles}</style>
    </div>
  );
}

Loading.defaultProps = {
  height: 'auto'
};

Loading.propTypes = {
  height: string
};

export default Loading;
